import * as React from "react";
import { StyleSheet, View, Text } from "react-native";
import { Text as ButtonText, Button } from "native-base";
import { currentLanguage } from "../../translations/CurrentLanguage";

import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, formatMoney } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

const get_tailorder_button = (props, currentTable) => {
  strings.setLanguage(currentLanguage().companyLanguage);
  if (props.isViewingOrder) {
    return (
      <Button
        small
        style={styles.button}
        disabled={currentTable === -1}
        onPress={props.onCancelOrder}
      >
        <ButtonText>{strings.CancelOrder}</ButtonText>
      </Button>
    );
  }
  return (
    <Button
      small
      style={styles.button}
      disabled={props.receipt.linesLength === 0}
      onPress={props.onTakeAwayClick}
    >
      <ButtonText>{strings.ConfirmOrder}</ButtonText>
    </Button>
  );
};

const GrandTotalComponent = props => {
  const {
    hasTailOrder,
    onViewOrders,
    currency,
    grandTotal,
    isCurrencyDisabled,
  } = props;
  strings.setLanguage(currentLanguage().companyLanguage);

  return (
    <View style={styles.header}>
      {hasTailOrder ? (
        <View style={styles.actions}>
          <Button small style={styles.button} onPress={onViewOrders}>
            <ButtonText>{strings.ViewOrders}</ButtonText>
          </Button>
          {get_tailorder_button(props, props.currentTable)}
        </View>
      ) : (
        <Text style={styles.label}>{strings.CurrentOrder}</Text>
      )}
      <Text style={styles.total} numberOfLines={1}>
        {formatMoney(grandTotal, currency, isCurrencyDisabled)}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    height: 60,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    backgroundColor: colors.navy,
    borderLeftWidth: 1,
    borderLeftColor: "rgba(255, 255, 255, 0.08)",
  },
  actions: {
    flexDirection: "row",
    alignItems: "center",
  },
  label: {
    color: "#9fb0c9",
    fontSize: 13,
    fontWeight: "600",
    letterSpacing: 0.4,
    textTransform: "uppercase",
  },
  total: {
    color: "#fff",
    fontWeight: "700",
    fontSize: 26,
    textAlign: "right",
  },
  button: {
    marginRight: 8,
    alignSelf: "center",
  },
});

export default GrandTotalComponent;
